import { render, staticRenderFns } from "./ACarousel.vue?vue&type=template&id=c1c4fe1c"
import script from "./ACarousel.vue?vue&type=script&lang=js"
export * from "./ACarousel.vue?vue&type=script&lang=js"
import style0 from "./ACarousel.vue?vue&type=style&index=0&id=c1c4fe1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports